import { render, staticRenderFns } from "./DepSignUpView.vue?vue&type=template&id=62694262&scoped=true&"
import script from "./DepSignUpView.vue?vue&type=script&lang=js&"
export * from "./DepSignUpView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62694262",
  null
  
)

export default component.exports